module.exports = __webpack_public_path__ + "static/media/banner2.4b3cd7d5.jpg";